import CustomTextField from "components/CustomTextField";
import React from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { useEffect, useState } from "react";
import Select from "react-select";
import Switch from "@mui/material/Switch";
import {
  useGetBlockBysubDstrictQuery,
  useGetDistrictByStateQuery,
  useGetStatesQuery,
  useGetSubDistrictQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import "react-multi-carousel/lib/styles.css";
import {
  useAddEmployeeMutation,
  useGetEmployeeByIdQuery,
  useUpdateEmployeeMutation,
} from "./UserManagementApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar } from "@mui/material";
import { useGetmasterRolesQuery } from "features/masterdata/MasterApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentRoles, selectCurrentUser } from "features/auth/authSlice";
import { Modal, Spinner } from "react-bootstrap";
import ReportingtoId from "./ReportingtoId";

const AddEmployeeHCL = ({
  isCreateComponent = false,
  cancelbutton,
  setPopUpAddEmployee,
  refetch,
}) => {
  const emp_id = useParams("id").id;

  const RolesFromToken = useSelector(selectCurrentRoles);
  const [isEditable, setIsEditable] = useState(isCreateComponent);
  const [addreporting, setAddReporting] = useState(isCreateComponent);
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setsubDistrictId] = useState("");
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [SubDistrictList, setSubDistrictList] = useState([]);
  const [rolesList, setCheckRolesList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [blockId, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [subDistrictName, setsubDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [zone, setZone] = useState("");
  const [designation, setDesignation] = useState("");
  const [domain, setDomain] = useState([]);
  const [addModel, setAddModel] = useState(false);
  const [ProfileModel, setProfileModel] = useState(false);
  const [activeValue, setActiveValue] = useState(true);
  const [submitDisableButton, setButtonDisable] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesId, setRolesId] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [assignedZoneCodes, setAssignedZoneCodes] = useState([]);
  const [employeeData, setEmployeeData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    DOB: "",
    department: "",
    employee_code: "",
    designation: "",
    roles: "",
    rolesId: "",
    assigned_zone: "",
    assigned_domains: "",
    assigned_zone_codes: "",
  });
  const navigate = useNavigate();

  const [phoneEnable, setPhoneEnable] = useState(false);
  const { data: getRoles } = useGetmasterRolesQuery();
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  const { data: dataSubDistrict } = useGetSubDistrictQuery(stateId, districtId);
  const { data: dataBlock } = useGetBlockBysubDstrictQuery(subDistrictId);
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const [AddEmployee] = useAddEmployeeMutation();

  const {
    data: employeeDataFromApi,
    isLoading,
    refetch: employeeDataRefetch,
    // } = useGetEmployeeByIdQuery( emp_id, {skip: !emp_id});
  } = useGetEmployeeByIdQuery(emp_id);

  const [updateEmployee] = useUpdateEmployeeMutation(emp_id);

  useEffect(() => {
    setEmployeeData({ ...employeeDataFromApi?.data });
    setDesignation(employeeDataFromApi?.data?.designation);
    if (emp_id) {
      setPhoneEnable(true);
    }
  }, [employeeDataFromApi]);

  // console.log(employeeData, " employeeData");

  // const handleRolesOptions = () => {
  //   let responseAgentArray = [];
  //   if(!RolesFromToken?.groups?.includes("admin")){
  //      var filteredList=rolesList.filter((item)=>item.name!=="admin")
  //       filteredList?.map((item) => {
  //         responseAgentArray.push({
  //           value: item.id,
  //           label: item.name,
  //           ConditionName: "Roles",
  //         });
  //       });
  //   }

  //  else{

  //   rolesList?.map((item) => {
  //     responseAgentArray.push({
  //       value: item.id,
  //       label: item.name,
  //       ConditionName: "Roles",
  //     });
  //   });
  // }
  //   return responseAgentArray;
  // };
  const handleRolesOptions = () => {
    let responseAgentArray = [];
    const filteredList = rolesList.filter((item) => {
      if (RolesFromToken?.groups?.includes("admin")) {
        return item.name !== "admin";
      }
      if (RolesFromToken?.groups?.includes("developer")) {
        return true; // Developer can see all roles
      }
      if (RolesFromToken?.groups?.includes("HR")) {
        return [
          "State Head",
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("State Head")) {
        return [
          "District Head",
          "Cluster Head",
          "Maker",
          "Checker",
          "FLE",
        ].includes(item.name);
      }
      if (
        RolesFromToken?.groups?.includes("District Head") ||
        RolesFromToken?.groups?.includes("Cluster Head")
      ) {
        return ["FLE"].includes(item.name);
      }
      if (RolesFromToken?.groups?.includes("CRM Admin")) {
        return ["CRM User"].includes(item.name);
      }

      if (RolesFromToken?.groups?.includes("Maker")) {
        return false; // Maker cannot see roles
      }
      if (RolesFromToken?.groups?.includes("Checker")) {
        return false; // Checker cannot see roles
      }
      if (RolesFromToken?.groups?.includes("CRM User")) {
        return false; // CRM User cannot see or edit roles
      }
      return false; // Default case: Show no roles
    });

    filteredList?.map((item) => {
      responseAgentArray.push({
        value: item.id,
        label: item.name,
        ConditionName: "Roles",
      });
    });

    return responseAgentArray;
  };

  const handleRole = (event) => {
    const values = event?.map((item) => {
      // console.log(item, "check irole item");
      return item.value;
    });
    const labels = event?.map((item) => {
      return item.label;
    });
    setRoles(labels);
    setRolesId(values);
  };

  const handleSingleRole = (event) => {
    setRoles(event.label);
    setRolesId(event.value);
  };
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };

  const handleSubDistrictOptions = () => {
    let responseAgentArray = [];
    SubDistrictList.map((sub_district) => {
      responseAgentArray.push({
        value: sub_district.sub_district_code,
        label: sub_district.sub_district_name,
        ConditionName: "Sub_district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };

  const onDistrictChange = (event) => {
    if (zone === "District") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
  };

  const onSubDistrictChange = (event) => {
    if (zone === "SubDistrict") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setsubDistrictId(event.value);
      setsubDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
  };
  const onBlockChange = (event) => {
    if (zone === "Block") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };

  const onLocationChange = (event) => {
    if (zone === "State") {
      const values = event?.map((item) => {
        return item.value;
      });
      const labels = event?.map((item) => {
        return item.label;
      });
      setSelectedZones(labels);
      setAssignedZoneCodes(values);
    } else {
      setStateId(event.value);
      setStateName(event.label);
    }
  };

  useEffect(() => {
    if (getRoles !== undefined) {
      setCheckRolesList(getRoles?.data);
    }
  }, [getRoles]);

  useEffect(() => {
    if (getStates !== undefined) {
      setStateList(getStates?.data?.results);
    }
  }, [getStates]);

  useEffect(() => {
    if (dataDistrict !== undefined) {
      setDistrictList(dataDistrict?.data?.results);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock !== undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);

  useEffect(() => {
    if (dataSubDistrict !== undefined) {
      setSubDistrictList(dataSubDistrict?.data?.results);
    }
  }, [dataSubDistrict]);

  const customStyles = {
    control: (base) => ({
      ...base,
      // height: 50,
      minHeight: 50,
    }),
  };

  const handleInputChange = (event) => {
    // console.log(event.target.name, "event");

    setEmployeeData({
      ...employeeData,
      [event.target.name]: event.target.value,
    });
  };

  const ZoneOptions = [
    { value: "State", label: "State" },
    { value: "District", label: "District" },
    { value: "Sub-District", label: "Sub-District" },
    { value: "Block", label: "Block" },
  ];

  const designationOptions = [
    { value: "Developer", label: "Developer" },
    { value: "Field Staff", label: " Field Staff" },
    { value: "Research", label: "Research" },
    { value: "HR", label: "HR" },
    { value: "Remote Sensing", label: "Remote Sensing" },
  ];

  const DomainOptions = [
    { value: "Banking", label: "Banking" },
    { value: "Insurance", label: "Insurance" },
    { value: "Survey", label: "Survey" },
    { value: "CRM", label: "CRM" },
    { value: "Procurement", label: "Procurement" },
  ];

  const handleZone = (e) => {
    setZone(e.value);
  };

  const handleDesignation = (e) => {
    setDesignation(e.target.value);
  };

  const handleDomain = (e) => {
    const domains = e.map((item) => {
      return item.value;
    });
    setDomain(domains);
  };

  useEffect(() => {
    if (employeeData?.roles) {
      setRoles(employeeData.roles);
    }
    setActiveValue(employeeData?.is_active);
  }, [employeeData]);

  // console.log(rolesId , " ROles ID")
  // console.log(domain , " Domain")
  // console.log(assignedZoneCodes , " Zone COdes")

  const handleEnabledButton = () => {
    let sendData = {
      is_active: !activeValue,
    };
    updateEmployee({ id: emp_id, payload: sendData })
      .unwrap()
      .then((data) => {
        if (data?.data?.is_active == true) {
          swal("Data Updated", {
            buttons: false,
            icon: "success",
            title: " Successfully Enabled",
            timer: 1500,
          });
          employeeDataRefetch();
          setProfileModel(false);
        } else if (data?.data?.is_active == false) {
          swal("Data Updated", {
            buttons: false,
            icon: "success",
            title: "Successfully Disabled",
            timer: 1500,
          });
          employeeDataRefetch();
          setProfileModel(false);
        }
      })
      .catch((e) => {
        swal("!!", {
          buttons: false,
          icon: "warning",
          title: "Something Went wrong",
          timer: 3000,
        });
      });
  };

  // console.log("assigned zone codes ", assignedZoneCodes);
  const handleSubmitButton = () => {
    const assignedDomains =
      domain.length > 0 ? domain : employeeData.assigned_domains;
    const assignedZoneCodes_ =
      assignedZoneCodes.length > 0
        ? assignedZoneCodes
        : employeeData.assigned_zone_codes;
    const assignedZones = zone.length > 0 ? zone : employeeData.assigned_zone;
    const staticZoneCode = ["9"];
    const staticZoneDomain = ["CRM"];

    let sendData = {
      first_name: employeeData?.first_name,
      last_name: employeeData?.last_name,
      phone_number: employeeData.phone_number,
      email: employeeData.email,
      DOB:
        employeeData?.DOB?.split("-")[0].length == 4
          ? employeeData?.DOB?.split("-")
              .reverse()
              .join("-")
          : employeeData?.DOB,
      department: employeeData.department,
      employee_code: employeeData.employee_code,
      designation: designation || employeeData.designation,
      assigned_zone:
        roles.includes("CRM Admin") || roles.includes("CRM User")
          ? "State"
          : assignedZones,
      assigned_zone_codes:
        roles.includes("CRM Admin") || roles.includes("CRM User")
          ? staticZoneCode
          : assignedZoneCodes_,
      assigned_domains:
        roles.includes("CRM Admin") || roles.includes("CRM User")
          ? staticZoneDomain
          : RoleAcessParams.includes("FPO")
          ? ["insurance"]
          : assignedDomains,
    };

    if (rolesId.length > 0) {
      sendData["roles"] = rolesId;
    }
    setButtonDisable(true);

    if (isCreateComponent) {
      AddEmployee(sendData)
        .unwrap()
        .then((data) => {
          if (data.success == true) {
            swal("Employee Added Successfully", {
              buttons: false,
              icon: "success",
              title: "Employee Added detail",
              timer: 1500,
            });
            setZone("");
            refetch();
            employeeDataRefetch();
            cancelbutton(false);
            setButtonDisable(false);
            setPopUpAddEmployee(false);
          }
        })

        .catch((data) => {
          // console.log(data.data.error, "line 152");
          if (data.data.error.code == 400) {
            swal("All Fields are mandatory", {
              buttons: false,
              icon: "warning",
              title: "Please fill full Details",
              timer: 1500,
            });
            setButtonDisable(false);

            return;
          } else if (data.data.error.code == 409) {
            swal("!!", {
              buttons: false,
              icon: "warning",
              title: data.data.error.message,
              timer: 2000,
            });
            setButtonDisable(false);
          }
        });
    } else if (!isCreateComponent) {
      updateEmployee({ id: emp_id, payload: sendData })
        .unwrap()
        .then((data) => {
          if (data?.success == true) {
            swal("Employee Data Updated Successfully", {
              buttons: false,
              icon: "success",
              title: "Data Updated ",
              timer: 1500,
            });
            setZone("");
            setIsEditable(!isEditable);
            employeeDataRefetch();
            setProfileModel(false);
            setButtonDisable(false);
          } else {
            swal("Missing Fields", {
              buttons: false,
              icon: "warning",
              title: "Please fill Full Details",
              timer: 1500,
            });
            setButtonDisable(false);
          }
          //   setTimeout(function(){
          //     window.location.reload();
          //  }, 2500);
        })
        .catch((e) => {
          swal("Missing Fields", {
            buttons: false,
            icon: "warning",
            title: "Please fill Full Details",
            timer: 3000,
          });
          setButtonDisable(false);
        });
    }
  };

  const handleEditButton = (clear) => {
    setPhoneEnable(true);
    setIsEditable(!isEditable);
    if (clear) {
      // console.log("empdata")
      employeeDataRefetch();
      setEmployeeData({ ...employeeDataFromApi?.data });
      setZone("");
    }
  };

  const handleAddModel = () => {
    setAddModel(true);
  };
  const handleClose = () => {
    setAddModel(false);
    setProfileModel(false);
  };

  const handleSwitchProfile = () => {
    setProfileModel(true);
  };
  const [checked, setChecked] = useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  // console.log("zone checking" ,zone)

  return (
    <>
      {/* {RoleAcessParams.includes("HCL")?
      <HclDashNav/>:""}  */}

      <div>
        {!isCreateComponent ? (
          <Row>
            {!isLoading ? (
              <>
                <Col lg="4">
                  <Card className="position-relative">
                    <div className="d-flex justify-content-between w-100 px-2  position-absolute">
                      <h5
                        className={
                          employeeData?.is_active
                            ? "text-success p-1"
                            : "text-secondary p-1"
                        }
                      >
                        {employeeData?.is_active ? "Enabled" : "Disabled"}{" "}
                      </h5>
                      <Switch
                        size="small"
                        color="success"
                        checked={employeeData?.is_active ? true : false}
                        onChange={handleSwitchProfile}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </div>
                    <CardBody
                      className="d-flex justify-content-center align-items-center "
                      style={{ padding: "1.2rem", minHeight: "150px" }}
                    >
                      <Col lg="4" className="">
                        <img
                          src={employeeData.profile_pic}
                          width="85px"
                          height="85px"
                          className="mx-4 mt-1"
                          style={{
                            border: "1px solid lightgrey ",
                            borderStyle: "dashed",
                            borderRadius: "8px",
                          }}
                        />
                      </Col>
                      <Col lg="8" className="mt-2 mx-2 ">
                        <h4>
                          <span className="text-success">
                            {employeeData.full_name}
                          </span>
                        </h4>
                        <h5 className="text-black m-0">
                          {employeeData.phone_number}
                        </h5>
                        <h5 className="text-black ">{employeeData.email}</h5>
                      </Col>
                    </CardBody>
                  </Card>
                </Col>
              </>
            ) : (
              <Col lg="4">
                <Card>
                  <CardBody
                    className="d-flex justify-content-center "
                    style={{ padding: "1.7rem", height: "150px" }}
                  >
                    <div
                      className="spinner-border align-self-center text-warning"
                      role="status"
                    >
                      <span className="sr-only"></span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}
            <Col lg="8">
              <Card
                // onClick={() => {
                //   navigate(`/user-management/${employeeData?.reporting_to.id}`);
                // }}
                style={{ cursor: "pointer" }}
              >
                <CardHeader className="d-flex justify-content-between m-0">
                  <div className="d-flex ">
                    {" "}
                    <Avatar
                      className="mt-1"
                      alt="Remy Sharp"
                      src={employeeData?.reporting_to?.profile_pic}
                      sx={{ width: 24, height: 24 }}
                    />
                    <span className="mx-2 mt-1">
                      {employeeData?.reporting_to?.full_name}
                    </span>
                  </div>

                  {RolesFromToken?.groups?.includes("admin") ||
                  RolesFromToken?.groups?.includes("HR") ? (
                    <Button
                      size="sm"
                      className="bg-primary border-0"
                      onClick={handleAddModel}
                    >
                      {employeeData?.reporting_to?.full_name ? "Edit" : "Add"}{" "}
                      {employeeData?.reporting_to?.full_name ? (
                        <span className="mdi mdi-account-edit fs-6"></span>
                      ) : (
                        <span className="mdi mdi-plus fs-6"></span>
                      )}
                    </Button>
                  ) : (
                    ""
                  )}
                </CardHeader>
                <Row style={{ padding: "0.8rem" }}>
                  <Col lg="3" className="">
                    <CustomTextField
                      name="full_name"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.full_name}
                      disabled={!addreporting}
                    />
                  </Col>
                  <Col lg="3" className="">
                    <CustomTextField
                      type="number"
                      name="phone_number"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.phone_number}
                      disabled={!addreporting}
                    />
                  </Col>
                  <Col lg="3" className="">
                    <CustomTextField
                      name="designation"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.designation}
                      disabled={!addreporting}
                    />
                  </Col>
                  <Col lg="3" className="">
                    <CustomTextField
                      name="employee_code"
                      onChange={handleInputChange}
                      value={employeeData?.reporting_to?.employee_code}
                      disabled={!addreporting}
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Card style={{ boxShadow: "none" }}>
          <CardBody className="p-3 ">
            <CardHeader className="mb-4 d-flex justify-content-between">
              <h5 className="mt-2">Basic Detail</h5>
              {!isCreateComponent ? (
                <Button
                  size="sm"
                  className={`${
                    isEditable ? "btn-danger" : "bg-primary border-0"
                  } float-right fs-6`}
                  onClick={() => handleEditButton(isEditable)}
                >
                  {isEditable ? "Cancel" : "Edit"}{" "}
                  {isEditable ? (
                    <span className="mdi mdi-close fs-6"></span>
                  ) : (
                    <span className="mdi mdi-account-edit fs-6"></span>
                  )}
                </Button>
              ) : (
                ""
              )}
            </CardHeader>
            <Row className="">
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="First Name"
                  name="first_name"
                  placeholder="Enter first name"
                  onChange={handleInputChange}
                  value={employeeData.first_name}
                  disabled={!isEditable}
                />
              </Col>

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="Last Name"
                  name="last_name"
                  placeholder="Enter last name"
                  onChange={handleInputChange}
                  value={employeeData.last_name}
                  disabled={!isEditable}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  maxlength="10"
                  label="Mobile No"
                  name="phone_number"
                  placeholder="123456789"
                  onChange={handleInputChange}
                  value={employeeData.phone_number}
                  disabled={!isEditable}
                  // disabled={phoneEnable == true ? true : false}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="email"
                  name="email"
                  placeholder="someone@example.com"
                  onChange={handleInputChange}
                  value={employeeData.email}
                  disabled={!isEditable}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="date"
                  name="DOB"
                  placeholder="25-02-2001"
                  onChange={handleInputChange}
                  defaultValue={employeeData?.DOB?.split("-")
                    .reverse()
                    .join("-")}
                  disabled={!isEditable}
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="Department"
                  name="department"
                  placeholder={isEditable ? "Enter Department" : ""}
                  onChange={handleInputChange}
                  value={employeeData.department}
                  disabled={!isEditable}
                />
              </Col>

              {isEditable ? (
                <Col lg="3" className="mb-2">
                  <CustomTextField
                    label="Designation"
                    name="designation"
                    onChange={handleDesignation}
                    value={designation}
                  />
                </Col>
              ) : (
                <Col lg="3" className="mb-3">
                  <CustomTextField
                    label="Designation"
                    name="designation"
                    disabled
                    value={designation || employeeData.designation}
                  />
                </Col>
              )}

              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  label="Employee Code"
                  name="employee_code"
                  placeholder="Enter code"
                  required
                  onChange={handleInputChange}
                  value={employeeData.employee_code}
                  disabled={!isEditable}
                />
              </Col>

              {isEditable ? (
                <Col lg="3" className=" mb-2">
                  <label className="text-black mb-2">
                    Roles <span className="text-danger">*</span>
                  </label>

                  <Select
                    // isMulti={roles.includes("CRM Admin") || roles.includes("CRM User")?false:true}
                    isMulti={true}
                    name="roles"
                    options={handleRolesOptions()}
                    // onChange={roles.includes("CRM Admin") || roles.includes("CRM User")?handleSingleRole:handleRole}
                    onChange={handleRole}
                    styles={customStyles}
                    // value={ roles?.map((item,index)=>{
                    //   return {
                    //     label :item,
                    //     value:item.value
                    //   }
                    // }) }
                  />
                </Col>
              ) : (
                <Col lg="3" className="mb-2">
                  <CustomTextField
                    label="Roles"
                    name="roles"
                    disabled
                    value={employeeData?.roles}
                  />
                </Col>
              )}
            </Row>

            {RoleAcessParams.includes("CBBO") ||
            roles.includes("CRM Admin") ||
            roles.includes("CRM User") ? (
              ""
            ) : (
              <Row>
                <CardHeader className="mb-3 mt-2">
                  <h5 className="mt-2">Operation Area</h5>
                </CardHeader>
                {isEditable && !RoleAcessParams.includes("FPO") ? (
                  <Col lg="3" className="mb-2">
                    <label className="text-black mb-2">
                      Assigned Domain <span className="text-danger">*</span>
                    </label>
                    <Select
                      isMulti
                      name="assigned_domains"
                      options={DomainOptions}
                      // value={domain || employeeData.assigned_domains}
                      placeholder={domain || employeeData?.assigned_domains}
                      onChange={handleDomain}
                      styles={customStyles}
                    />
                  </Col>
                ) : // <Col lg="3" className="mb-3">
                //   <CustomTextField
                //     label="assigned_domains"
                //     name="assigned_domains"
                //     disabled
                //     value={
                //       RoleAcessParams.includes("FPO")
                //         ? ["insurance"]
                //         : employeeData.assigned_domains
                //     }
                //   />
                // </Col>
                null}

                {isEditable ? (
                  <Col lg="3" className="mb-2">
                    <label className="text-black mb-2">
                      Assigned Zone <span className="text-danger">*</span>
                    </label>
                    <Select
                      name="assigned_zone"
                      options={ZoneOptions}
                      placeholder={zone || employeeData.assigned_zone}
                      // defaultValue={{ label: employeeData.assigned_zone, value: 0 }}

                      onChange={handleZone}
                      styles={customStyles}
                    />
                  </Col>
                ) : (
                  <Col lg="3" className="mb-3">
                    <CustomTextField
                      label="assigned_zone"
                      name="assigned_zone"
                      disabled
                      value={employeeData.assigned_zone}
                    />
                  </Col>
                )}
                {isEditable ? (
                  <Col lg="3" className="mb-4 ">
                    <label className="text-black mb-2"> Selected {zone}</label>
                    <CustomTextField
                      name=""
                      disabled
                      value={selectedZones}
                      styles={customStyles}
                    />
                  </Col>
                ) : (
                  <Col lg="6" className="mb-4 ">
                    <label className="text-black mb-2">
                      {" "}
                      Selected {employeeData.assigned_zone}
                    </label>
                    <CustomTextField
                      name=""
                      disabled
                      value={employeeData?.assigned_zone_code_names}
                      styles={customStyles}
                    />
                  </Col>
                )}

                <Row>
                  {zone === "State" ||
                  zone === "District" ||
                  zone === "Block" ||
                  zone === "Sub-District" ? (
                    <Col lg="3" className="mb-4">
                      <label className="text-black mb-2"> State</label>
                      <Select
                        isMulti={zone === "State" ? true : false}
                        options={handleStateOptions()}
                        onChange={onLocationChange}
                        placeholder={
                          stateId === "" ? "Select State" : stateName
                        }
                        // value={stateId === "" ? "Select State" : stateName}
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}

                  {zone === "District" ||
                  zone === "Sub-District" ||
                  zone === "Block" ? (
                    <Col lg="3" className="mb-4 ">
                      <label className="text-black mb-2"> District</label>
                      <Select
                        isMulti={zone === "District" ? true : false}
                        menuPlacement="auto"
                        options={handleDistrictOptions()}
                        onChange={onDistrictChange}
                        isOptionDisabled={() =>
                          RolesFromToken?.groups?.includes("admin")
                            ? false
                            : selectedZones.length >= 3
                        }
                        placeholder={
                          districtId == "" ? "Select District" : districtName
                        }
                        // value={
                        //   districtId === "" ? "Select District" : districtName
                        // }
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                  {zone === "Sub-District" || zone === "Block" ? (
                    <Col lg="3" className="mb-4 ">
                      <label className="text-black mb-2">Sub-District</label>
                      <Select
                        isMulti={zone === "Sub-District" ? true : false}
                        menuPlacement="auto"
                        options={handleSubDistrictOptions()}
                        onChange={onSubDistrictChange}
                        isOptionDisabled={() =>
                          RolesFromToken?.groups?.includes("admin")
                            ? false
                            : selectedZones.length >= 3
                        }
                        placeholder={
                          subDistrictId == ""
                            ? "Select Sub-District"
                            : subDistrictName
                        }
                        // value={
                        //   subDistrictId === ""
                        //     ? "Select Sub-District"
                        //     : subDistrictName
                        // }
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                  {zone === "Block" ? (
                    <Col lg="3" className="mb-4 ">
                      <label className="text-black mb-2"> Block</label>
                      <Select
                        isMulti={zone === "Block" ? true : false}
                        menuPlacement="auto"
                        options={handleBlockOptions()}
                        onChange={onBlockChange}
                        placeholder={blockId == "" ? "Select Block" : blockName}
                        isOptionDisabled={() =>
                          RolesFromToken?.groups?.includes("admin")
                            ? false
                            : selectedZones.length >= 3
                        }
                        // value={blockId === "" ? "Select Block" : blockName}
                        className="SelectAgentClass text-black"
                        styles={customStyles}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </Row>
            )}

            <Button
              className={`btn btn-success p-2 fs-6 me-2 px-3 `}
              style={{ float: "right" }}
              onClick={handleSubmitButton}
            >
              Submit &nbsp;
              {submitDisableButton ? (
                <Spinner animation="border" size="sm" className="text-center" />
              ) : (
                ""
              )}
            </Button>
          </CardBody>
          <Modal show={addModel} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
              <Modal.Title style={{ color: "" }} className="fw-bold">
                Add/Edit Reporting Manager
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-5">
              <ReportingtoId id={emp_id} />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
          </Modal>

          <Modal show={ProfileModel} onHide={handleClose} size="md">
            <Modal.Header closeButton>
              <Modal.Title style={{ color: "" }} className="fw-bold">
                {activeValue ? "Disable User" : "Enable User"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
              <div className="">
                <h4 className="text-gray text-center mt-3">
                  Are you Sure to Want to {activeValue ? "Disable " : "Enable "}{" "}
                  <strong className="text-black">
                    {employeeData.full_name}
                  </strong>{" "}
                  ?
                </h4>
              </div>
              <div className="">
                {" "}
                <p className="text-gray text-italic text-bottom  mt-4 mb-0">
                  <strong>Note : </strong>
                  {activeValue
                    ? "Users will not be able to login or perform any actions if they are disabled."
                    : "Enabled uses can login and perform actions based on the assigned roles"}
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-danger waves-effect me-2"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="btn btn-success waves-effect me-2"
                onClick={handleEnabledButton}
              >
                {activeValue ? "Disable " : "Enable"}
              </button>
            </Modal.Footer>
          </Modal>
        </Card>
      </div>
    </>
  );
};

export default AddEmployeeHCL;
